import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Typography,
    Autocomplete, TextareaAutosize,
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCuttingList } from '../../Store/PHPSlice/Cutting/cuttingApi';
import { errorStyles } from '../../Utils/table';
import { fetchReturnMemoNo, fetchStitchDepartQty, fetchStitchEmplist, fetchStitchMemoNo, StitchingEntry } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchEmplist, selectStitchingMemoNo, selectCuttingReturnMemo, selectStitchDepartQty } from '../Selectors/StitchSelector/StitchingSelectors';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { StitchEntrylist } from '../TitleList';
import { selectCutReturnlist } from '../Selectors/Master/ItemSelectors';
import { fetchDepartmentData, fetchEmpDepartWise } from '../../Store/PHPSlice/Department';
import { selectDaparement, selectDeptEmp, selectPartyInwData, selectPartyInwDataMemo } from '../Selectors/Master/MasterSelectors';
import Dropdown from '../FieldsComponents/Dropdown';
import { fetchPartyInwardData, fetchPartyInwardMemo } from '../../Store/PHPSlice/PartyInward/PartyInwApi';

const StitchInhouseEntry = () => {

    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        reId: '',
        empNm: '',
        stitchNo: '',
        stitchNo2: '',
        reMemo: '',
        piMemo: '',
        itemId: '',
        itemId2: '',
        itemNm: '',
        brandId: '',
        brandNm: '',
        partyId: '',
        partyNm: '',
        userId: '1',
        depart: '',
        departNm: '',
        giventotqty: '',
        totqty: '',
        totmat: '',
        totissue: '',
        totbal: '',
        remainqty: '',
        remainqty2: ''
    });
    const [errors, setErrors] = useState({});
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [material, setMaterial] = useState([]);
    const [itemQty, setItemQty] = useState([]);
    const [stitchingComp, setStitchingComp] = useState(false);
    const [departlist, setDepartlist] = useState([]);
    const actionMap = {
        master: fetchCuttingList,
        // Add more mappings if needed
    };
    const dispatch = useDispatch();
    const returnMemo = useSelector(selectCuttingReturnMemo);
    const stemplist = useSelector(selectDeptEmp);
    const stMemoNo = useSelector(selectStitchingMemoNo);
    const depart = useSelector(selectDaparement);
    const partyInwdata = useSelector(selectPartyInwDataMemo);
    const partyInwdata2 = useSelector(selectPartyInwData);

    const stitchDepartQty = useSelector(selectStitchDepartQty);

    // console.log(stitchingComp);
    useEffect(() => {
        dispatch(fetchReturnMemoNo());
        dispatch(fetchStitchMemoNo());
        dispatch(fetchDepartmentData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (stMemoNo?.data) {
            const item = stMemoNo?.data?.stitchNo;
            setFormData(prev => ({
                ...prev,
                stitchNo: item,
                stitchNo2: item
            }))
        }
    }, [stMemoNo]);

    useEffect(() => {
        if (partyInwdata2?.material2?.length > 0) {
            const data = JSON.parse(JSON.stringify(partyInwdata2?.material2));
            setMaterial(data);
        }
        if (partyInwdata2?.itemdata2?.length > 0) {
            const data2 = JSON.parse(JSON.stringify(partyInwdata2?.itemdata2));
            setItemQty(data2);
        }
        if (partyInwdata2?.data) {
            const totqty = partyInwdata2?.data?.totqty;
            const totmat = partyInwdata2?.data?.balmtqty;
            const data = partyInwdata2?.data;
            setFormData(prev => ({
                ...prev,
                totmat: totmat,
                giventotqty: totqty,
                partyId: data?.partyId,
                partyNm: data?.partyNm,
                brandId: data?.brandId,
                brandNm: data?.brandNm,
                itemId2: data?.itemId
            }));
        }
        if (partyInwdata2?.stitchDepart?.length > 0) {
            const datas = partyInwdata2?.stitchDepart;
            const results = depart?.data?.filter(item1 =>
                !datas.some(item2 => item1.ID === item2.departId)
            );
            setDepartlist(results);
        } else {
            setDepartlist(depart?.data);
        }
    }, [partyInwdata2]);

    useEffect(() => {
        if (stitchDepartQty?.data) {
            const remainqty = stitchDepartQty?.data;
            setFormData(prev => ({
                ...prev,
                remainqty: remainqty?.balqty || prev.giventotqty,
                remainqty2: remainqty?.balqty || prev.giventotqty
            }))
        }
    }, [stitchDepartQty]);

    // console.log(itemQty);
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let newValue = value.toUpperCase();

        if (name === 'totqty' && value) {
            const enteredQty = parseFloat(value);
            const remainingQty = parseFloat(formData.remainqty2);

            if (enteredQty > remainingQty) {
                alert(`Qty is less than ${remainingQty}`);
                newValue = ''; // Reset totqty if it exceeds remainqty
            } else {
                // Subtract entered totqty from remainqty
                setFormData({
                    ...formData,
                    totqty: newValue,
                    remainqty: (remainingQty - enteredQty).toFixed(2) // Update remainqty
                });
                return;
            }
        } else {
            setFormData({
                ...formData,
                totqty: '',
                remainqty: formData.remainqty2
            });
        }

        setFormData({
            ...formData,
            [name]: newValue
        });
    };


    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'depart':
                if (value) {
                    dispatch(fetchEmpDepartWise(value));
                    const selectDept = depart?.data?.find(emp => emp.ID === value);
                    const departnm = selectDept?.departNm;
                    // console.log('DepartNm',departnm);

                    if (departnm.includes('STITCHING') || departnm.includes('STICHING')) {
                        setStitchingComp(true);
                    } else if (departnm.includes('KAJE')) {
                        setStitchingComp(true);
                    }
                    else {
                        setStitchingComp(false);
                    }
                    const postdata = {
                        pinwId: parseFloat(formData.itemId),
                        departId: value
                    };
                    dispatch(fetchStitchDepartQty(postdata));
                }
                break;

            case 'reMemo':
                if (value) {
                    // dispatch(fetchPartyInwardData(value));
                    dispatch(fetchPartyInwardMemo(value));
                    const selectPImemo = returnMemo?.data?.find((val) => val.ID === value);
                    setFormData(prev => ({
                        ...prev,
                        piMemo: selectPImemo?.piMemo
                    }));
                } else {
                    setMaterial([]);
                    setItemQty([]);
                    setFormData(prev => ({
                        ...prev,
                        giventotqty: '',
                        totqty: '',
                        totmat: ''
                    }))
                }
                break;

            case 'itemId':
                if (value) {
                    dispatch(fetchPartyInwardData(value));

                } else {
                    setMaterial([]);
                    setItemQty([]);
                    setFormData(prev => ({
                        ...prev,
                        giventotqty: '',
                        totqty: '',
                        totmat: ''
                    }))
                }
                break;
            default:
                break;
        }
    };
    // console.log(stitchingComp);
    const handleLumpSelection = (index) => {
        const newRows = [...material];
        newRows[index].selected = !newRows[index].selected;
        setMaterial(newRows);
    };

    const handleLumpColor = (index, value, name) => {
        const updatematerial = [...material];
        if (updatematerial[index].balqty >= value) {
            updatematerial[index].issqty = value;
            updatematerial[index].remainqty = value > 0 ? updatematerial[index].balqty - parseFloat(value) : 0;
        }
        else if (updatematerial[index].balqty < value) {

            // If entered value is greater than balqty, set value to balqty
            updatematerial[index].issqty = updatematerial[index].balqty;
            updatematerial[index].remainqty = 0;
        }
        setMaterial(updatematerial);

        const totissueqty = updatematerial.reduce((acc, qty) => {
            const issqty = parseFloat(qty.issqty);
            if (!isNaN(issqty)) {
                return acc + issqty;
            }
            return acc;
        }, 0);

        const totbalqty = updatematerial.reduce((acc, qty) => acc + parseFloat(qty.remainqty), 0);

        setFormData(prev => ({
            ...prev,
            totissue: totissueqty,
            totbal: totbalqty
        }));

    };

    const handleSizeQty = (index, value) => {
        const updatematerial = [...itemQty];
        if (updatematerial[index].balqty >= value) {
            updatematerial[index].issqty = value;
            updatematerial[index].remainqty = value > 0 ? updatematerial[index].balqty - parseFloat(value) : 0;
        }
        else if (updatematerial[index].balqty < value) {

            // If entered value is greater than balqty, set value to balqty
            updatematerial[index].issqty = updatematerial[index].balqty;
            updatematerial[index].remainqty = 0;
        }
        setItemQty(updatematerial);

        const totissueqty = updatematerial.reduce((acc, qty) => {
            const issqty = parseFloat(qty.issqty);
            if (!isNaN(issqty)) {
                return acc + issqty;
            }
            return acc;
        }, 0);

        const remainqtys = updatematerial.reduce((acc, qty) => {
            const issqty = parseFloat(qty.balqty);
            if (!isNaN(issqty)) {
                return acc + issqty;
            }
            return acc;
        }, 0);

        const final_remain = parseFloat(remainqtys) - parseFloat(totissueqty);


        setFormData(prev => ({
            ...prev,
            totqty: totissueqty,
            remainqty: final_remain
        }));

    };


    function convertIntoOneObject(formData, material, itemQty) {
        const data = {
            brandId: formData.brandId,
            depart: formData.depart,
            dt: formData.dt,
            empId: formData.empNm,
            gtotqty: formData.giventotqty,
            instructions: formData.instructions,
            itemId: formData.itemId2,
            partyId: formData.partyId,
            pinwId: formData.itemId,
            piMemo: formData.reMemo,
            stMemo: formData.stitchNo,
            stMemo2: formData.stitchNo2,
            totbal: formData.totbal,
            totissue: formData.totissue,
            totmat: formData.totmat,
            totqty: formData.totqty,
            userId: formData.userId,
            material: material,
            itemQty: itemQty
        }
        return data;
    }
    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.empNm) {
            alert('select Employee');
            return;
        }
        if (!formData.totqty || formData.totqty === '') {
            alert("Enter Total Qty is required.");
            return; // Stop the submission if validation fails
        }
        const finalObject = convertIntoOneObject(formData, material, itemQty);
        // console.log(finalObject)
        dispatch(StitchingEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Stitching Added");
                alert("Records Added");
                window.location.reload();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };

    const dropdownlistfirst = [
        {
            label: 'Item',
            id: 'item',
            options: partyInwdata?.data || [],
            value: formData.itemId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            }
        },
        {
            label: 'Department',
            id: 'depart',
            options: departlist || [],
            value: formData.depart,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'depart', value: newValue ? newValue.ID : '' } }, 'depart'),
            getOptionLabel: (option) => option.departNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            }
        }
    ];

    const handlenavigateparty = () => {
        window.open(`/new-employee`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TitleBar data={StitchEntrylist} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Job Given Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Memo No.', name: 'stitchNo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="reMemo">PI Ref. No.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="reMemo"
                                                    name="reMemo"
                                                    options={Array.isArray(returnMemo?.data) ? returnMemo.data : []}
                                                    getOptionLabel={(option) => option.piMemo || ''}
                                                    value={returnMemo?.data?.find(item => item.piMemo === formData.reMemo) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'reMemo', value: newValue ? newValue.piMemo : '' } }, 'reMemo')}
                                                    // onOpen={() => handleDropdownOpen('reMemo')}
                                                    // onClose={() => handleDropdownClose('reMemo')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            // label="Select an option"
                                                            variant="outlined"
                                                            placeholder='Select an option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.piMemo === value.piMemo}
                                                />

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}
                                        />
                                    ))
                                }

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="empNm">Master Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="empNm"
                                                    name="empNm"
                                                    options={stemplist?.data}
                                                    getOptionLabel={(option) => option.empNm || ''}
                                                    value={stemplist?.data?.find(item => item.ID === formData.empNm) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'empNm', value: newValue ? newValue.ID : '' } }, 'empNm')}
                                                    // onOpen={() => handleDropdownOpen('empNm')}
                                                    // onClose={() => handleDropdownClose('empNm')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            // label="Select an option"
                                                            variant="outlined"
                                                            placeholder='Select an option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                                                />


                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handlenavigateparty} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {[
                                    { label: 'Party', name: 'partyNm' },
                                    { label: 'Brand', name: 'brandNm' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id={field.name}
                                                    >
                                                        {formData[field.name] || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    [
                                        { label: 'Given Total Qty.', name: 'giventotqty', type: 'readOnly' },
                                        { label: 'Remain Qty.', name: 'remainqty', type: 'readOnly' },
                                        { label: 'Total Qty.', name: 'totqty' }
                                    ].map((field, index) => (
                                        <Grid item xs={12} md={6} key={index}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {field.type === 'date' ? (
                                                            <TextField
                                                                id={field.name}
                                                                name={field.name}
                                                                type="date"
                                                                value={formData[field.name]}
                                                                onChange={handleDateChange}
                                                                inputProps={{ style: styled.cutDate }}
                                                                sx={inputStyles}
                                                            />
                                                        ) : (
                                                            <TextField
                                                                id={field.name}
                                                                name={field.name}
                                                                value={formData[field.name]}
                                                                onChange={handleInputChange}
                                                                inputProps={{ style: styled.input, readOnly: field.type }}
                                                                sx={inputStyles}
                                                            />
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    ))
                                }

                                <Grid item xs={12} md={6}></Grid>
                                <Grid item xs={12} md={6}>
                                    {material?.length > 0 &&
                                        <div>
                                            <h3>Material Details </h3>
                                            <table style={{ width: '100%' }}>
                                                <thead>
                                                    <tr>
                                                        <th>Sr. No.</th>
                                                        <th>Material Work</th>
                                                        <th>Given Qty.</th>
                                                        <th>Issue Qty.</th>
                                                        <th>Bal Qty.</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {material?.map((mat, matIndex) => (
                                                        <>
                                                            <tr key={matIndex}>
                                                                <td><input
                                                                    type="checkbox"
                                                                    checked={mat.selected}
                                                                    onChange={() => handleLumpSelection(matIndex)}
                                                                />{" "}
                                                                    {matIndex + 1}
                                                                </td>
                                                                <td>
                                                                    {mat.materialNm}
                                                                </td>
                                                                <td>
                                                                    {mat.balqty}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="0"
                                                                        value={mat.issqty}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            // Check if the value is numeric and less than or equal to balqty
                                                                            if (value && parseFloat(value) <= mat.balqty) {
                                                                                handleLumpColor(matIndex, parseFloat(value), "issqty");
                                                                            } else if (value === '') {
                                                                                handleLumpColor(matIndex, parseFloat(value), "issqty");  // Allow clearing the input
                                                                            } else {
                                                                                // Optionally reset or show an error if value is greater than balqty
                                                                                alert("Issue Quantity cannot be greater than Balance Quantity");
                                                                            }
                                                                        }}
                                                                        style={{ width: '50px' }}
                                                                        disabled={!mat.selected}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {mat.remainqty}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    ))}
                                                    <tr>
                                                        <td> </td>
                                                        <td>
                                                            <span className="tot-lump">Total Qty</span>
                                                        </td>
                                                        <td>
                                                            <span className="tot-lump">{formData.totmat}</span>
                                                        </td>
                                                        <td>
                                                            <span className="tot-lump">{formData.totissue}</span>
                                                        </td>
                                                        <td>
                                                            <span className="tot-lump">{formData.totbal}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                </Grid>
                                {stitchingComp == true && itemQty?.length > 0 &&
                                    <Grid item xs={12} md={6}>
                                        <div>
                                            <h3>Item Details</h3>
                                            <table style={{ width: '100%' }}>
                                                <tbody>
                                                    <tr>
                                                        <td>Size</td>
                                                        {itemQty?.map((val, valIndex) => (
                                                            <td key={valIndex}>
                                                                {val.size}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                    <tr>
                                                        <td>Given Qty.</td>
                                                        {itemQty?.map((val, valIndex) => (
                                                            <td key={valIndex}>
                                                                {val.balqty}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                    <tr>
                                                        <td>Issue Qty.</td>
                                                        {itemQty?.map((val, valIndex) => (
                                                            <td key={valIndex}>
                                                                <input
                                                                    type="text"
                                                                    placeholder="0"
                                                                    value={val.issqty}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        // Check if the value is numeric and less than or equal to balqty
                                                                        if (value && parseFloat(value) <= val.balqty) {
                                                                            handleSizeQty(valIndex, parseFloat(value));
                                                                        } else if (value === '') {
                                                                            handleSizeQty(valIndex, parseFloat(value));  // Allow clearing the input
                                                                        } else {
                                                                            // Optionally reset or show an error if value is greater than balqty
                                                                            alert("Issue Quantity cannot be greater than Balance Quantity");
                                                                        }
                                                                    }}
                                                                    style={{ width: '50px' }}
                                                                />
                                                            </td>
                                                        ))}
                                                    </tr>
                                                    <tr>
                                                        <td>Bal Qty.</td>
                                                        {itemQty?.map((val, valIndex) => (
                                                            <td key={valIndex}>
                                                                {val.remainqty}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </Grid>
                                }

                                {[
                                    { label: 'Instructions', name: 'instructions' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        style={{ ...styled.input, width: '100%' }}
                                                        readOnly={field.type === 'readOnly'}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StitchInhouseEntry;
